import createAxiosInstance from '../support/AxiosSupport';

export interface TwoFactorStatus {
    enabled: boolean;
    /** Сколько одноразовых recovery-кодов ещё не использовано. */
    recoveryCodesRemaining: number;
}

export interface TwoFactorSetup {
    secret: string;
    otpauthUri: string;
}

interface TwoFactorEnableResult {
    enabled: boolean;
    /** Recovery-коды; приходят от сервера ровно один раз. */
    recoveryCodes: string[];
}

/** Текущий статус 2FA пользователя. */
export async function getStatus(): Promise<TwoFactorStatus> {
    const api = await createAxiosInstance();
    const {data} = await api.get<TwoFactorStatus>('/2fa/status');
    return data;
}

/** Начать подключение: получить секрет и otpauth-ссылку для QR. */
export async function setup(): Promise<TwoFactorSetup> {
    const api = await createAxiosInstance();
    const {data} = await api.post<TwoFactorSetup>('/2fa/setup');
    return data;
}

/** Подтвердить подключение кодом из аутентификатора. Возвращает recovery-коды. */
export async function enable(code: string): Promise<string[]> {
    const api = await createAxiosInstance();
    const {data} = await api.post<TwoFactorEnableResult>('/2fa/enable', {code});
    return data.recoveryCodes || [];
}

/** Отключить 2FA (требует действующий TOTP- или recovery-код). */
export async function disable(code: string): Promise<void> {
    const api = await createAxiosInstance();
    await api.post('/2fa/disable', {code});
}
